// Utility functions for feature detection and compatibility checks
export const checkFeatureSupport = () => {
  const features = {
    serviceWorker: 'serviceWorker' in navigator,
    fetch: 'fetch' in window,
    localStorage: (() => {
      try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
        return true;
      } catch (e) {
        return false;
      }
    })(),
    webShare: 'share' in navigator,
    webp: (() => {
      try {
        const elem = document.createElement('canvas');
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
      } catch (e) {
        return false;
      }
    })(),
  };
  
  return features;
};

export const initializePolyfills = async () => {
  const needsPolyfills = !window.Promise || !window.fetch || !window.Object.assign;
  
  if (needsPolyfills) {
    try {
      await import('core-js/stable');
      await import('regenerator-runtime/runtime');
    } catch (e) {
      console.error('Error loading polyfills:', e);
    }
  }
};

export const preserveQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.toString()) {
    try {
      sessionStorage.setItem('queryParams', params.toString());
    } catch (e) {
      console.error('Error saving query params:', e);
    }
  }
};

export const restoreQueryParams = () => {
  try {
    const params = sessionStorage.getItem('queryParams');
    if (params) {
      sessionStorage.removeItem('queryParams');
      return `?${params}`;
    }
  } catch (e) {
    console.error('Error restoring query params:', e);
  }
  return '';
};